/**
 * Guard de /proyectos y /proyectos/:id: deja pasar con `projects.view` o con
 * membresía en algún proyecto (ver `useAccesoAProyectos`). Qué proyectos ve
 * cada uno lo sigue decidiendo la RLS.
 *
 * Mientras no se sabe, no decide: devolver «Sin acceso» durante la carga es lo
 * que `RequirePermission` ya aprendió a no hacer.
 */
import type { ReactNode } from 'react';

import { NoAccessPage } from '@/features/shared/NoAccessPage';

import { useAccesoAProyectos } from './useAccesoAProyectos';

export function ProjectsAccessGuard({ children }: { children: ReactNode }) {
  const { puede, cargando } = useAccesoAProyectos();
  if (cargando) return null;
  return <>{puede ? children : <NoAccessPage />}</>;
}
